export default "__VITE_ASSET__df7e4817__"